module.exports = __webpack_public_path__ + "img/magazine41.318727ca.jpg";